/**
 * Detects iOS devices including iPadOS 13+ which reports as "Macintosh"
 * in desktop mode but still has touch support.
 */
export const isIOSDevice = (): boolean =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
